import React from 'react';

const words = [
  'NON', 'SIAMO', 'IL', 'FUTURO.', 'SIAMO', 'IL', 'PRESENTE',
  'CHE', 'NON', 'CHIEDE', 'PERMESSO.', 'COSTRUIAMO', 'ALTERNATIVE,',
  'DIFENDIAMO', 'I', 'DIRITTI,', 'PROTEGGIAMO', "L'AMBIENTE.", 'ORA.',
];

const ManifestoSection = () => {
  return (
    <section className="section manifesto-section">
      <div className="container">
        <p className="manifesto-text">
          {words.map((word, i) => (
            <span key={i}>{word}</span>
          ))}
          {' '}
        </p>
      </div>
    </section>
  );
};

export default ManifestoSection;
